import styled from 'styled-components';

export const MoveList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/** An attack's button reads like the card: cost, name, damage. */
export const MoveLabel = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const MoveName = styled.span`
  flex: 1;
  margin: 0 8px;
  text-align: left;
`;

export const MoveDamage = styled.span`
  font-variant-numeric: tabular-nums;
`;
